"use client";

import { useEffect, useRef } from "react";
import styles from "./supportTooltip.module.scss";

interface SupportTooltipProps {
  onDismiss: () => void;
}

export default function SupportTooltip({ onDismiss }: SupportTooltipProps) {
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        onDismiss();
      }
    };

    // Add listener with a small delay to prevent immediate dismissal
    const DISMISSAL_DELAY_MS = 100;
    const timeoutId = setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, DISMISSAL_DELAY_MS);

    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("click", handleClickOutside);
    };
  }, [onDismiss]);

  return (
    <div ref={tooltipRef} className={styles.tooltipContainer} onClick={onDismiss} role="tooltip">
      <div className={styles.tooltipTail}>
        <div className={styles.tooltipArrow} />
      </div>
      <div className={styles.tooltipBody}>
        <p className={styles.tooltipText}>Use Live Chat in the Support Menu to continue your conversation</p>
      </div>
    </div>
  );
}
